module.exports = __webpack_public_path__ + "static/media/hover.40b79346.gif";